// 自主智能体
export const AutonomousAgentCode = 'autonomous_agent';
